// @ts-ignore
import lottie from "lottie-web";

const selectors: Record<"block", string> = {
  block: "[data-lottie-bacchus-leopard]",
};

const SVG_PATH: Record<"brown" | "raspberry" | "cherry", string> = {
  brown: "/wp-content/themes/vanhonsebrouck/src/img/images/bacchus-brown-leopard.json",
  raspberry: "/wp-content/themes/vanhonsebrouck/src/img/images/bacchus-raspberry-leopard.json",
  cherry: "/wp-content/themes/vanhonsebrouck/src/img/images/bacchus-cherry-leopard.json",
};

function init() {
  const block = document.querySelector(selectors.block) as HTMLElement;

  if (!block) return;

  // @ts-ignore
  const type: "brown" | "raspberry" | "cherry" =
    block.getAttribute("data-lottie-bacchus-leopard") || "brown";

  const animItem = lottie.loadAnimation({
    // @ts-ignore
    wrapper: block,
    animType: "svg",
    loop: true,
    path: SVG_PATH[type],
  });
}

document.addEventListener(
  "DOMContentLoaded",
  async function () {
    init();
  },
  {
    once: true,
  }
);
